import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdSearchValueObject} from './FilterIdSearchValueObject.js'

export class FilterSellerTypeIdSearchValueObject extends ValueObject {
  #sellerTypeId

  constructor({sellerTypeId}) {
    super()
    this.#sellerTypeId = sellerTypeId
  }

  static create({sellerTypeId}) {
    return new FilterSellerTypeIdSearchValueObject({sellerTypeId: FilterIdSearchValueObject.create(sellerTypeId)})
  }

  static createWithDefaultValue({config, sellerTypeId}) {
    const {DEFAULT_SELLER_TYPE_ID_SEARCH} = config.get('searchFilters')

    return new FilterSellerTypeIdSearchValueObject({
      sellerTypeId: FilterIdSearchValueObject.create({id: sellerTypeId ?? DEFAULT_SELLER_TYPE_ID_SEARCH})
    })
  }

  static createFromUrl({config, sellerTypeId, url = ''}) {
    const {SEMANTIC_KEYWORDS} = config.get('seo')
    const isRenting = url.startsWith('/renting/')

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.TARGET_BUYER_PRIVATE)) {
      return new FilterSellerTypeIdSearchValueObject({
        sellerTypeId: 0
      })
    }

    return FilterSellerTypeIdSearchValueObject.createWithDefaultValue({
      config,
      sellerTypeId
    })
  }

  static createQueryParams({config, sellerTypeId}) {
    const {DEFAULT_SELLER_TYPE_ID_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterSellerTypeIdSearchValueObject({
      sellerTypeId: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.SELLER_TYPE],
        value: sellerTypeId === DEFAULT_SELLER_TYPE_ID_SEARCH ? null : sellerTypeId
      })
    })
  }

  get isEmpty() {
    return this.#sellerTypeId.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#sellerTypeId.queryParam})
    }
  }

  get value() {
    return this.#sellerTypeId.value
  }

  toJSON() {
    return {
      sellerTypeId: this.#sellerTypeId.toJSON()
    }
  }
}
